export const capitalizeFirstLetter = (input: string): string => {
  return input
    .split(',')
    .map((word) => word.trim())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(', ');
};

// Turns a slug-like raw value (dots/underscores as separators) into a title-
// cased display string, e.g. "active_classification.arizona" -> "Active
// Classification Arizona".
export const humanize = (raw: string): string =>
  raw
    .replace(/[._]/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
